import { useState } from "react";
import { Clock, ChevronDown, ChevronUp } from "lucide-react";

function ago(iso) {
  try {
    const diff = (Date.now() - new Date(iso).getTime()) / 36e5;
    if (diff < 1) return "just now";
    if (diff < 24) return `${Math.round(diff)}h ago`;
    return `${Math.round(diff / 24)}d ago`;
  } catch {
    return "";
  }
}

export default function NewsCard({ item }) {
  const [open, setOpen] = useState(false);
  const long = (item.summary || "").length > 160;
  return (
    <article className="panel panel-hover p-5 flex flex-col gap-3" data-testid={`news-card-${item.id}`}>
      <div className="flex items-center justify-between">
        <span className="text-[10px] font-bold tracking-widest text-smasher-orange bg-smasher-orange/10 px-2 py-0.5 rounded">
          {item.category}
        </span>
        <span className="inline-flex items-center gap-1 text-[11px] text-slate-500"><Clock className="w-3 h-3" /> {ago(item.published)}</span>
      </div>
      <h3 className="font-heading font-bold text-lg leading-tight text-white">{item.title}</h3>
      <p className={`text-sm text-slate-400 leading-relaxed whitespace-pre-line ${open ? "" : "line-clamp-3"}`}>{item.summary}</p>
      <div className="flex items-center justify-between border-t border-white/5 pt-3 mt-auto">
        <span className="text-[10px] font-bold tracking-widest text-slate-500">SMASHER DESK</span>
        {long && (
          <button
            onClick={() => setOpen(!open)}
            className="inline-flex items-center gap-1 text-xs font-bold text-smasher-gold hover:text-smasher-orange transition-colors"
            data-testid={`news-read-more-${item.id}`}
          >
            {open ? "SHOW LESS" : "READ MORE"} {open ? <ChevronUp className="w-3.5 h-3.5" /> : <ChevronDown className="w-3.5 h-3.5" />}
          </button>
        )}
      </div>
    </article>
  );
}
